import Column from '@app/components/layout/Column'
import { Link } from 'wouter'
import { useMemo, useState } from 'react'
import { TextInput } from '@app/components/core/input/text/TextInput'
import { faSearch } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'

interface ElearningItemSidebarProps {
  items?: {
    slug: string
    title: string
  }[]
  activeSlug?: string
}

export const ElearningItemSidebar = ({
  items,
  activeSlug,
}: ElearningItemSidebarProps) => {
  const t = useTranslations().app.elearningPage
  const [searchField, setSearchField] = useState('')

  const filteredItems = useMemo(() => {
    return items?.filter((item) =>
      item.title.toLowerCase().includes(searchField.toLowerCase()),
    )
  }, [items, searchField])

  return (
    <>
      <Column gap="1rem">
        <TextInput
          text={searchField}
          setText={setSearchField}
          placeholder={t.searchPlaceholder}
          icon={faSearch}
          style={{ width: '100%', marginBottom: '0.5rem' }}
        />

        <Column gap={0} style={{ marginTop: '0.5rem', width: '100%' }}>
          <Title.H4>{t.sidebarTitle}</Title.H4>
          {filteredItems?.map((ki) => {
            const isActive = activeSlug === ki.slug

            return (
              <Link
                key={ki.slug}
                href={pages.elearningItem(ki.slug)}
                style={{
                  textDecoration: 'none',
                  width: '100%',
                  padding: '0.75rem 0.5rem',
                  backgroundColor: isActive
                    ? 'var(--palette-steady-stone)'
                    : 'transparent',
                  borderRadius: '0.5rem',
                }}
              >
                <Text.Medium
                  style={{
                    '&:hover': { color: 'var(--palette-blue-500)' },
                  }}
                >
                  {ki.title}
                </Text.Medium>
              </Link>
            )
          })}
        </Column>
      </Column>
    </>
  )
}
